import React, { createContext, useState, ReactNode, useContext } from "react";

// 1. Create the context
interface BooleanContextType {
  isTrue: boolean;
  toggle: () => void;
  setIsTrue: (value: boolean) => void;
}

const BooleanContext = createContext<BooleanContextType | undefined>(undefined);

// 2. Provider component
export const BooleanProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isTrue, setIsTrue] = useState(false);

  const toggle = () => setIsTrue((prev) => !prev);

  return (
    <BooleanContext.Provider value={{ isTrue, toggle, setIsTrue }}>
      {children}
    </BooleanContext.Provider>
  );
};

// 3. Custom hook to consume context
export const useBoolean = () => {
  const context = useContext(BooleanContext);
  if (!context) throw new Error("useBoolean must be used within BooleanProvider");
  return context;
};
